import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from "./auth/components/login/login.component";
import {CanLoadGuard} from "./auth/guards/can-load/can-load-guard.service";
import {StradiaRoutes} from "./shared/enum/routes.enum";

const routes: Routes = [
  {
    path: StradiaRoutes.LOGIN,
    component: LoginComponent,
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canLoad: [CanLoadGuard],
  },
  { path: '', redirectTo: StradiaRoutes.LOGIN, pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
